'use client';

import classNames from 'classnames';
import Link from 'next/link';
import { useState } from 'react';
import { useEventListener } from 'usehooks-ts';

import styles from './main.module.scss';

export default function Top() {
  const [hasBg, setHasBg] = useState(false);
  // 헤더 스크롤 이벤트
  const headerScrollEvent = () => {
    const scrollPos = window.scrollY;
    const changePos = 0;
    setHasBg(scrollPos > changePos);
  };

  useEventListener('scroll', headerScrollEvent);

  return (
    <header className={classNames({ [styles.bg]: hasBg })}>
      <div className={styles.pad}>
        <Link href="/" className="logo" aria-label="이실장 홈으로 이동"></Link>
      </div>
    </header>
  );
}
